/**
 * In-memory holder for the just-created booking response (createTrip → data).
 * Mirrors the plugin's state/bookingResult.js.
 *
 * WHY a module variable instead of sessionStorage:
 * This data is only needed for the post-booking terminal steps (bookingReceived
 * and the perk/return views it links to). It must survive in-session step
 * navigation (bookingReceived ↔ findingDriver / flightDelayed / perks) but should
 * be GONE on a real page reload — module memory clears on reload automatically,
 * so there is nothing to clean up and no stale value can linger. The post-booking
 * steps are also excluded from step persistence (NON_PERSISTED_STEPS), so a reload
 * never lands back on them with a null result.
 *
 * The stored object is the raw createTrip `data` ({ trip, return_booking_data, … })
 * with `trip_direction` ('from_airport' | 'to_airport' | 'others') attached, so the
 * bookingReceived perk buttons can branch on direction without re-reading the
 * destinations (which are wiped right after booking).
 */
let bookingResult = null;

// Has the "Booking received" success spinner already animated for the CURRENT
// result? Kept here (not in sessionStorage) so it survives the bookingReceived
// unmount/remount when the user opens a perk step and comes back, but resets for
// each new booking and dies on reload. Replaces the old SPINNER_SPUN_KEY.
let confirmationSpun = false;

export function setBookingResult(data) {
  bookingResult = data;
  confirmationSpun = false; // new booking → let the spinner animate once
}

export function getBookingResult() {
  return bookingResult;
}

export function clearBookingResult() {
  bookingResult = null;
  confirmationSpun = false;
}

export function hasConfirmationSpun() {
  return confirmationSpun;
}

export function markConfirmationSpun() {
  confirmationSpun = true;
}
